var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": null,
    "options": {
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "LiveDetailInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "uid",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "username",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "avatar",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "gender",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "signature",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "grade",
                    "id": 6
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "location",
                    "id": 7
                },
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "roomId",
                    "id": 8
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "onlineTotal",
                    "id": 9
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "roomTitle",
                    "id": 10
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "liveMsg",
                    "id": 11
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "officialAuth",
                    "id": 12
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "officialAuthContent",
                    "id": 13
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "qualityAuth",
                    "id": 14
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "upliveCode",
                    "id": 15
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "countryCode",
                    "id": 16
                },
                {
                    "rule": "optional",
                    "type": "double",
                    "name": "distance",
                    "id": 17
                }
            ]
        },
        {
            "name": "BannerInfo",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "images",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "rank",
                    "id": 2
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "endTime",
                    "id": 3
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "jump",
                    "id": 4
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "type",
                    "id": 5
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "activeBeginTime",
                    "id": 6
                },
                {
                    "rule": "optional",
                    "type": "int32",
                    "name": "activeEndTime",
                    "id": 7
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "activeLabel",
                    "id": 8
                }
            ]
        },
        {
            "name": "Feed",
            "fields": [],
            "messages": [
                {
                    "name": "FollowList",
                    "fields": [],
                    "options": {
                        "objc_class_prefix": "FeedFollowList",
                        "java_package": "com.asiainno.uplive.proto"
                    },
                    "messages": [
                        {
                            "name": "Request",
                            "fields": [
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "page",
                                    "id": 1
                                },
                                {
                                    "rule": "optional",
                                    "type": "int32",
                                    "name": "pageSize",
                                    "id": 2
                                }
                            ]
                        },
                        {
                            "name": "Response",
                            "fields": [
                                {
                                    "rule": "repeated",
                                    "type": "LiveDetailInfo",
                                    "name": "infos",
                                    "id": 2
                                },
                                {
                                    "rule": "repeated",
                                    "type": "BannerInfo",
                                    "name": "banners",
                                    "id": 3
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
}).build();

export default _root;


// WEBPACK FOOTER //
// ./js/header/follow/followlist.pb.js